import React, { useState, useEffect, useCallback } from 'react';
import { Row } from 'react-bootstrap';
import HVASpinner from 'components/base/HVASpinner';
import QAScorecardQuestions from './QAScorecardQuestions';
import { fetchHVAScorecardQuestions } from 'services/hvaqa.service';

interface QAScorecardData4Props {
  scorecardid: number;
  startdate: Date;
  enddate: Date;
  serviceid: number;
  campaignid: number;
  agentid: number;
}

const QAScorecardData4: React.FC<QAScorecardData4Props> = ({
  scorecardid,
  startdate,
  enddate,
  serviceid,
  campaignid,
  agentid
}) => {
  // eslint-disable-next-line
  const [questionsData, setQuestionsData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);

  // Función para obtener los datos
  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await fetchHVAScorecardQuestions(scorecardid);
      setQuestionsData(response);
    } catch (err) {
      console.error('Error al recuperar las preguntas del scorecard: ', err);
      // Considera añadir un estado para manejar errores
    } finally {
      setLoading(false);
    }
  }, [scorecardid]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <>
      {loading ? (
        <Row className="justify-content-center align-items-center pt-3 w-100">
          <HVASpinner />
        </Row>
      ) : (
        <>
          <Row className="mb-1 mx-n3 px-0 pt-1 justify-content-start align-items-top">
            <h4>Scorecard details (score value by question)</h4>
            <p className="fs-9 mb-0">
              Questions with higher weight contribute more to the global
              scorecard score. Score shown is the adjusted with manual scores
              introduced by the QA team.
            </p>
            {questionsData && (
              <QAScorecardQuestions
                questionsData={questionsData}
                scorecardid={scorecardid}
                startdate={startdate}
                enddate={enddate}
                serviceid={serviceid}
                campaignid={campaignid}
                agentid={agentid}
              />
            )}
          </Row>
        </>
      )}
    </>
  );
};

export default React.memo(QAScorecardData4);
